export const SOLUTIONS_HERO_ITEMS = [
  "Unify every scattered system",
  "Search across every tool at once",
  "Automate the manual busywork",
  "Score risk with evidence attached",
  "Catch fraud before payout",
  "Explain every AI decision",
  "Audit every override",
];

export const SOLUTIONS_BLOCKS = [
  {
    id: "unified-knowledge",
    index: "01",
    pill: "INTELLIGENCE",
    pillClass: "is-intelligence",
    title: "Unified knowledge",
    body:
      "No more re-keying the same submission data across five disconnected systems. One intelligence layer, one shared context, for every team.",
    bullets: [
      "Unified search across every connected system",
      "Context-aware workflow automation",
    ],
    reverse: false,
    muted: false,
    visual: "unified",
  },
  {
    id: "explainable-decisions",
    index: "02",
    pill: "INSURANCE",
    pillClass: "is-insurance",
    title: "Faster, explainable decisions",
    body:
      "Underwriters get a risk score with the evidence and reasoning behind it — decide with confidence, not guesswork, and cut manual review time.",
    bullets: ["Evidence-backed risk scoring", "Every recommendation shows its reasoning"],
    reverse: true,
    muted: true,
    visual: "decisions",
  },
  {
    id: "fraud-risk",
    index: "03",
    pill: "INSURANCE",
    pillClass: "is-insurance",
    title: "Fraud & risk caught early",
    body:
      "Fraud, severity, and leakage scored continuously — flagging what needs investigation before payout, not after the damage is done.",
    bullets: ["Real-time fraud & severity scoring", "Dedicated investigation workspace"],
    reverse: false,
    muted: false,
    visual: "fraud",
  },
  {
    id: "audit-ready",
    index: "04",
    pill: "BOTH LAYERS",
    pillClass: "is-both",
    title: "Audit-ready by default",
    body:
      "Every decision and override is logged with timestamp, user, and justification — so the next compliance review is a formality, not a fire drill.",
    bullets: ["Full audit trail on every override", "Role-based access, by design"],
    reverse: true,
    muted: true,
    visual: "audit",
  },
];

export const SOLUTIONS_SCRUTINY_CARDS = [
  {
    title: "OVERRIDE ACCESS",
    bodyParts: [
      "Restricted to ",
      { strong: "Admin, Tenant Admin, and Super Admin" },
      " roles only — never a request awaiting sign-off, always a direct, justified action.",
    ],
  },
  {
    title: "AUDIT TRAIL ACCESS",
    bodyParts: [
      "Visible to ",
      { strong: "Admin, Tenant Admin, and Super Admin" },
      " — every other role is blocked at the permission layer, not just hidden in the UI.",
    ],
  },
  {
    title: "OVERRIDE REQUIRES REASON",
    bodyParts: [
      "Every override needs a ",
      { strong: "non-empty justification" },
      " before it's accepted — no silent overrides, ever.",
    ],
  },
];

export const SOLUTIONS_FAQS = [
  {
    question: "Do I need Insurance and Intelligence as separate products?",
    answer:
      "No. Highwatch Insurance is built on top of the Intelligence layer — it's included, not a separate purchase or integration.",
  },
  {
    question: "Who can access the audit trail and override decisions?",
    answer:
      "Audit trail access and override actions are restricted to Admin, Tenant Admin, and Super Admin roles. Every other role is blocked at the permission level.",
  },
  {
    question: "What's logged in the audit trail?",
    answer:
      "Every decision and override, with timestamp, the user who acted, and their justification reason — nothing is logged anonymously or without cause.",
  },
  {
    question: "What happens when Finance or Healthcare launches?",
    answer:
      "They run on the same explainable intelligence layer as Insurance — no separate platform to learn or migrate to.",
  },
];
